import { redirect, useNavigate } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { setPendingModal } from "../../../libs/pending-modal";

export const Route = createFileRoute("/_authed/charge/complete")({
  beforeLoad: ({ context: { tenant } }) => {
    if (!tenant.feature.charge) {
      throw redirect({ to: "/" });
    }
  },
  component: ChargeComplete,
});

function ChargeComplete() {
  const navigate = useNavigate();

  useEffect(() => {
    setPendingModal({ type: "charge-completed" });
    navigate({ to: "/", replace: true });
  }, [navigate]);

  return null;
}
